import React from 'react'

const Jva_perm = () => {
    return (
        <div className='container'>
            <article id="post-526" class="post-526 post type-post status-publish format-standard hentry category-java">
     
      
     <h2><span id="algorithm-for-permutation-of-a-string-in-java">Algorithm for Permutation of a String in
                 Java</span></h2>
     <p>We will first take the first character from the String and permute with the remaining chars.</p>
    
     <p>If String = “ABC”</p>
     <p>First char = A and remaining chars permutations are BC and CB.</p>
     <p>Now we can insert first char in the available positions in the permutations.</p>
     
     <p>BC -&gt; ABC, BAC, BCA</p>

     <p>CB -&gt; ACB, CAB, CBA</p>
     <p>We can write a recursive function to return the permutations and then another function to insert the
           first characters to get the complete list of permutations.</p>
     <h2><span id="java-program-to-print-permutations-of-a-string">Java Program to Print Permutations of a
                 String</span></h2>
     <pre className='containers'><code class="hljs javascript">package com.journaldev.java.string; <br/>

<span class="keywords">import</span> java.util.HashSet; <br/>
<span class="keywords">import</span> java.util.Set; <br/>

<br/> <br/>
public <span class="hljs-class"><span class="keywords">class</span> <span class="hljs-title">StringFindAllPermutations</span> </span>&#123; <br/>
public <span class="keywords">static</span> <span class="library">Set</span>&lt;<span class="library">String</span>&gt; permutationFinder(<span class="library">String</span> str) &#123; <br/>
<span class="library">Set</span>&lt;<span class="library">String</span>&gt; perm = <span class="keywords">new</span> HashSet&lt;<span class="library">String</span>&gt;(); <br/>
<span class="comment">//Handling error scenarios</span> <br/>
<span class="keywords">if</span> (str == <span class="hljs-literal">null</span>) &#123; <br/>
<span class="keywords">return</span> <span class="hljs-literal">null</span>; <br/>
&#125; <span class="keywords">else</span> <span class="keywords">if</span> (str.length() == <span class="hljs-number">0</span>) &#123; <br/>
perm.add(<span class="hljs-string">""</span>); <br/>
<span class="keywords">return</span> perm; <br/>
&#125; <br/>
char initial = str.charAt(<span class="hljs-number">0</span>); <span class="comment">// first character</span> <br/>
<span class="library">String</span> rem = str.substring(<span class="hljs-number">1</span>); <span class="comment">// Full string without first character</span> <br/>
<span class="library">Set</span>&lt;<span class="library">String</span>&gt; words = permutationFinder(rem); <br/>
<span class="keywords">for</span> (<span class="library">String</span> strNew : words) &#123; <br/>
<span class="keywords">for</span> (int i = <span class="hljs-number">0</span>;i&lt;=strNew.length();i++)&#123; <br/>
   perm.add(charInsert(strNew, initial, i)); <br/>
&#125; <br/>
&#125; <br/>
<span class="keywords">return</span> perm; <br/>
&#125; <br/>
<br/>
public <span class="keywords">static</span> <span class="library">String</span> charInsert(<span class="library">String</span> str, char c, int j) &#123; <br/>
<span class="library">String</span> begin = str.substring(<span class="hljs-number">0</span>, j); <br/>
<span class="library">String</span> end = str.substring(j); <br/>
<span class="keywords">return</span> begin + c + end; <br/>
&#125; <br/>
<br/>
public <span class="keywords">static</span> <span class="keywords">void</span> main(<span class="library">String</span>[] args) &#123; <br/>
<span class="library">String</span> s = <span class="hljs-string">"AAC"</span>; <br/>
<span class="library">String</span> s1 = <span class="hljs-string">"ABC"</span>; <br/>
<span class="library">String</span> s2 = <span class="hljs-string">"ABCD"</span>; <br/>
System.out.println(<span class="hljs-string">"\nPermutations for "</span> + s + <span class="hljs-string">" are: \n"</span> + permutationFinder(s)); <br/>
System.out.println(<span class="hljs-string">"\nPermutations for "</span> + s1 + <span class="hljs-string">" are: \n"</span> + permutationFinder(s1)); <br/>
System.out.println(<span class="hljs-string">"\nPermutations for "</span> + s2 + <span class="hljs-string">" are: \n"</span> + permutationFinder(s2)); <br/>
&#125; <br/>
&#125; <br/>
</code></pre> <br/>
     <p>I have usedSet to store the string permutations. <br/>
           So that duplicates are removed automatically.</p> <br/>
     <h2><span id="output">Output</span></h2> <br/>
     <pre className='containers'><code class="hljs objectivec">Permutations <span class="keywords">for</span> AAC are: <br/> <br/>
[AAC, ACA, <span class="library">CAA</span>] <br/>
<br/>
Permutations <span class="keywords">for</span> ABC are:  <br/> <br/>
[ACB, ABC, BCA, CBA, <span class="library">CAB</span>, BAC] <br/>
<br/>
Permutations <span class="keywords">for</span> ABCD are: <br/> <br/>
[DABC, <span class="library">CADB</span>, BCAD, DBAC, BACD, ABCD, ABDC, DCBA, ADBC, ADCB, CBDA,<br /> CBAD, DACB, ACBD, CDBA, CDAB, DCAB, ACDB, DBCA,<br /> BDAC, <span class="library">CABD</span>, BADC, BCDA <br/>, BDCA]
</code></pre> <br/>
     <p>That’s all for finding all permutations of a String in Java.</p> <br/>
     <br/>
<br/>
</article> 
        </div>
    )
}

export default Jva_perm
